import styled from 'styled-components';

export const Text = styled.span`
  font-weight: 500;
`;
